module.exports = __webpack_public_path__ + "static/img/11.366adbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/11.png
// module id = 3jLB
// module chunks = 0